(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('whiteDialog', function() {
    return {
      restrict: 'E',
      scope: { title: '@dialogTitle', close: '&' },
      transclude: true,
      templateUrl: '/m/whiteDialog.html?_hv=bf86d1d'
    };
  });
})(window, window.angular);
